export class NavBarObject {
    text;
    route;
    value;
    children;

    constructor(text: string, route: any, value: string | number, children?: NavBarObject[]) {
        this.text = text;
        this.route = route;
        this.value = value;
        this.children = children;
    }
}

export const MOCK: NavBarObject[] = [
    new NavBarObject('2017 - 2018', ['/estudio/resumen', 37], 37,
        [
            new NavBarObject('Periodo I', ['/estudio/resumen', 15], 15),
            new NavBarObject('Periodo II', ['/estudio/resumen', 16], 16)
        ]),
    new NavBarObject('2016 - 2017', ['/estudio/resumen', 20], 20,
        [
            new NavBarObject('Periodo I', ['/estudio/resumen', 21], 21),
            new NavBarObject('Periodo II', ['/estudio/resumen', 22], 22)
        ])
]